import { useState } from "react";

interface AccessControl {
  feature_name: string;
  access_code: string;
  visibility_duration_minutes: number;
  last_verified_at: string;
  is_disabled: boolean;
}

export const useAccessCodesState = (accessControls: AccessControl[] | undefined) => {
  const [authorizedFeatures, setAuthorizedFeatures] = useState<string[]>([]);
  const [accessCodes, setAccessCodes] = useState<Record<string, string>>({});

  if (accessControls) {
    const features = (accessControls as AccessControl[])
      .filter(item => item.access_code !== null && item.access_code !== '' && !item.is_disabled)
      .map(item => item.feature_name);

    if (JSON.stringify(features) !== JSON.stringify(authorizedFeatures)) {
      setAuthorizedFeatures(features);
    }

    const codeMap = accessControls.reduce((acc, item) => ({
      ...acc,
      [item.feature_name]: item.access_code
    }), {});
    
    if (JSON.stringify(codeMap) !== JSON.stringify(accessCodes)) {
      setAccessCodes(codeMap);
    }
  }

  return {
    authorizedFeatures,
    accessCodes,
  };
};